import Vue from 'vue'

import Page from '../layout/Page.vue'
import Sample from '../layout/Sample.vue'
import ExampleCode from '../layout/ExampleCode.vue'
import Step from '../layout/Step.vue'

Vue.component('page', Page)
Vue.component('sample', Sample)
Vue.component('example-code', ExampleCode)
Vue.component('step', Step)
